import React, { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from './../context/AuthProvider';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Titulo, Formulario, FormularioGrid, Label, InputRadio, Wrapper, Item, RadioButton, RadioButtonLabel, InputCheck, ContenedorTerminos, ContenedorAutorizacion, PoliticasDatosPersonales, ContenedorBotonCentrado, BotonAmarillo, BotonGris, MensajeExito, MensajeError, MensajeDocumentos } from '../elementos/FormFicha';
import { BotonAmarilloModal, BotonGrisModal, TextoRojoModal } from '../elementos/FormModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faSmileWink } from '@fortawesome/free-solid-svg-icons';
import ComponenteInput from './Input';
import ComponenteSelectSexo from './SelectSexo';
import ComponenteSelectRelacion from './SelectRelacion';
import SelectDocumento from './SelectDocumento';
import SelectHorario from './SelectHorario';
import SelectUbicacion from './SelectUbicacion';
import { Header, LogoOscuro } from '../elementos/Headers';
import { Footer } from '../elementos/Footers';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Registro from './Registro';
import Documentos from './Documentos';
import '../estilos.css';
import ProgressIntoDialog from '../componentes/Progress/Progress';
import SimpleReactValidator from 'simple-react-validator';
import { Navigate } from 'react-router-dom';
import VentanaModalion from './VentanaModal';
import VentanaModalDatosPersonales from './VentanaModalDatosPersonales';
import { ContenedorCentrado, TextoAmarillo, TextoNegro } from '../elementos/FormRegistro';
import UploaderDocument from './UploaderDocument';
import MensajeValidacion from './MensajeValidacion';
import Check from 'react-bootstrap/FormCheck';
import { Radio } from '@material-ui/core';


const baseUrlCRM = process.env.REACT_APP_URL_API_CRM;
const baseUrlGDO = process.env.REACT_APP_URL_API_GDO;
const FICHA_URL = '/fichas_matricula';
const apiKeyGDO = process.env.REACT_APP_APIKEY_GDO;
const apiKeyCRM = process.env.REACT_APP_APIKEY_CRM;

const baseUrlVul = process.env.REACT_APP_URL_VULNERABILIDAD;
const urlAPIVulnerabilidad = process.env.REACT_APP_API_VULNERABILIDAD;

// Unidades de negocio
const UNIDADES_NEGOCIO = {
  PG: process.env.REACT_APP_COD_UND_NEGOCIO_PG,
  WA: process.env.REACT_APP_COD_UND_NEGOCIO_WA,
  WV: process.env.REACT_APP_COD_UND_NEGOCIO_WV,
  WAS: process.env.REACT_APP_COD_UND_NEGOCIO_WAS,
  EPEC: process.env.REACT_APP_COD_UND_NEGOCIO_EPEC
};

// Modalidades de estudio
const MODALIDADES_ESTUDIO = {
  PRESENCIAL: process.env.REACT_APP_COD_MOD_ESTUDIO_PRESENCIAL,
  SEMIPRESENCIAL: process.env.REACT_APP_COD_MOD_ESTUDIO_SEMIPRESENCIAL,
  DISTANCIA: process.env.REACT_APP_COD_MOD_ESTUDIO_DISTANCIA
};

const Ficha = ({ guid_oportunidad, usuarios, version_crm, jwtUsuario }) => {

  guid_oportunidad = localStorage.getItem("GUID");
  version_crm = localStorage.getItem("version_crm");
  usuarios = localStorage.getItem("user");
  jwtUsuario = localStorage.getItem("jwtUsuario");

  const errRef = useRef();
  const [loading, setLoading] = useState(false);

  const [idFichaMatricula, setFichaMatricula] = useState(null);
  const [edadActual, setedadActual] = useState(0);
  const [valorTipoFicha, setvalorTipoFicha] = useState(0);
  const [modadlidadIngreso, setmodadlidadIngreso] = useState(0);

  /* Datos Personales */
  const [datoUsuario, setPost] = useState([]);
  const [departamento, setDep] = useState({ guid: '', nombre: '' });
  const [provincia, setProv] = useState({ guid: '', nombre: '' });
  const [distrito, setDist] = useState({ guid: '', nombre: '' });
  const [direccion, setDireccionNew] = useState('');
  const [telefonoFijo, setTelefonoFijoNew] = useState('');
  const [celular, setCelularNew] = useState('');
  const [correoElectronico, setCorreoElectronicoNew] = useState('');
  const [Documento, setDocumento] = useState({ codigo: '', nombre: '', numero: '' });

  /* Datos Apoderado*/
  const [Relacion, setRelacion] = useState({ id: '', nombre: '' });
  const [Ocupacion, setOcupacion] = useState('')
  const [NombresApoderado, setNombresApoderado] = useState('')
  const [ApellidoPaternoApoderado, setApellidoPaternoApoderado] = useState('');
  const [ApellidoMaternoApoderado, setApellidoMaternoApoderado] = useState('')
  const [DireccionApoderado, setDireccionApoderado] = useState('')
  const [celularApoderado, setcelularApoderado] = useState('')
  const [mailApoderado, setmailApoderado] = useState('')
  const [NumeroDocumentoApoderado, setNumeroDocumentoApoderado] = useState('')
  const [DepApoderado, setDepApoderado] = useState({ guid: '', nombre: '' });
  const [ProvApoderado, setProvApoderado] = useState({ guid: '', nombre: '' });
  const [DistApoderado, setDistApoderado] = useState({ guid: '', nombre: '' });
  const [DocumentoApoderado, setDocumentoApoderado] = useState({ codigo: '', nombre: '', numero: '' });
  const [TelefonoCasaApoderado, setTelefonoCasaApoderado] = useState('')
  /* Datos Declaraciónes */
  const [datosDeclaracion, setPostDeclaracion] = useState([]);
  const [PostObtenerRegistroId, setPostObtenerRegistroId] = useState('')
  /* Datos Información Laboral*/
  const [tipoTrabajo, setTipoTrabajoNew] = useState('1');
  const [tipoPoliticaPersonales,settipoPoliticaPersonales]=useState('');
  const [razonSocialTrab, setRazonSocialTrabNew] = useState('');
  const [rucTrab, setRucTrabNew] = useState('');
  const [departamentoTrab, setDepartamentoTrabNew] = useState({ guid: '', nombre: '' });
  const [provinciaTrab, setProvinciaTrabNew] = useState({ guid: '', nombre: '' });
  const [distritoTrab, setDistritoTrabNew] = useState({ guid: '', nombre: '' });
  const [telefonoTrab, setTelefonoTrabNew] = useState('');
  const [anexoTrab, setAnexoTrabNew] = useState('');
  const [autorizoOpcionalmenteUsoDatosPersonalesNew, setAutorizoOpcionalmenteUsoDatosPersonalesNew] = useState(false);
  const [aceptoTyCNew, setAceptoTyCNew] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [successRegistro, setSuccessRegistro] = useState(false);
  const [showModal, setShow] = useState(false);
  const [activarBoton, setactivarBoton] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [esobligatorioVal, setesobligatorioVal] = useState(true);
  const [esobligatoriounvalor,setesobligatoriounvalor]=useState('');
  const [NavegacionRetroceder, setNavegacionRetroceder] = useState(false);
  const [vistaCargaDocumento, setvistaCargaDocumento] = useState({ id: '', nombre: '', url: '', visible: false });
  const [CargaMatrizDocumento, setCargaMatrizDocumento] = useState(true);
  const [GuidSubModalidad, setGuidSubModalidad] = useState();
  const [cargaExitosaSubModalidad, setcargaExitosaSubModalidad] = useState(true);
  const [PeriodoBanner, setPeriodoBanner] = useState('');
  const [valorChecket,setvalorChecket]=useState(false);
  const [valorChecket2,setvalorChecket2]=useState(false);
  const [urlVulnerabilidad, setUrlVulnerabilidad] = useState('');
  const [txtVulnerabilidad, setTxtVulnerabilidad] = useState('1');

  const [Horarios,setHorarios]=useState({codigo:'',nombreHorario:''});

  var ImgRegistro = require('./../wwwroot/images/img-upn2.png');


  const handleRadioButton = (event) => {
    const value = event.target.value;

    validator.current.purgeFields();
    setTipoTrabajoNew(value);

    if (value == 2) {
      setesobligatorioVal(false);
      limpiartInputInformacionLaboral()
    } else if (value == 1) {
      setesobligatorioVal(true);
    }
  };

  const handleRadioButtonPoliticas = (event) => {
    const value = event.target.value;
    validator.current.purgeFields();
    settipoPoliticaPersonales(value);


    if (value == 1) {
      setesobligatoriounvalor(true);
    } else if (value == 2) {
      setesobligatoriounvalor(false);
    }
  };

  const handleAutorizoOpcionalmenteUsoDatosPersonalesNew = (event) => {
    const value = event.target.checked;

    if (value == "1") {
      setAutorizoOpcionalmenteUsoDatosPersonalesNew(true);
    } else if (value == "0") {
      setAutorizoOpcionalmenteUsoDatosPersonalesNew(false);
    }
  };

  const handleDeclaracion = (event) => {
    const value = event.target.value;
    let checked = event.target.checked;
    checked = (checked == true ? checked : '');
    setPostDeclaracion(
      datosDeclaracion.map(item =>
        item.id == value
          ? { ...item, isChecked: checked }
          : item));
  }

  const handleHorario = (codigo, nombre) => {
    setHorarios({ codigo:codigo, nombre:nombre});
  }




  SimpleReactValidator.addLocale('es', {
    accepted: ':attribute debe ser aceptado.',
    after: ':attribute debe ser una fecha posterior a :date.',
    after_or_equal: ':attribute debe ser una fecha posterior o igual a :date.',
    alpha: ':attribute sólo debe contener letras.',
    array: ':attribute debe ser un conjunto.',
    before: ':attribute debe ser una fecha anterior a :date.',
    before_or_equal: ':attribute debe ser una fecha anterior o igual a :date.',
    between: ':attribute tiene que estar entre :min - :max:type.',
    boolean: 'El campo :attribute debe tener un valor verdadero o falso.',
    date: ':attribute no es una fecha válida.',
    date_equals: ':attribute debe ser una fecha igual a :date.',
    email: ':attribute no es un correo válido',
    in: ':attribute es inválido :values.',
    integer: ':attribute debe ser un número entero.',
    max: 'El :attribute no debe ser mayor a :max carácteres.',
    min: 'El :attribute debe ser de al menos :min carácteres.',
    not_in: ':attribute es inválido :values.',
    not_regex: 'El formato del campo :attribute no es válido.',
    numeric: 'El :attribute debe ser numérico.',
    regex: 'El formato de :attribute es inválido.',
    required: 'El campo :attribute es obligatorio.',
    size: 'El tamaño de :attribute debe ser :size:type.',
    string: 'El campo :attribute debe ser una cadena de caracteres.',
    url: 'El formato :attribute es inválido.',
  });

  const [, forceUpdate] = useState();
  const validator = useRef(new SimpleReactValidator({ locale: 'es', autoForceUpdate: { forceUpdate: forceUpdate } }))


  function obtenerRegistro(guid) {
    setLoading(true);
    var auth = {
      headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyCRM, "version-crm": version_crm }
    };
    axios.get(baseUrlCRM + 'api/oportunidades/' + guid, auth)
      .then(response => {
        var docs = response.data
        console.log(response.data);

        if (docs.guid_submodalidad_ingreso == null || docs.guid_submodalidad_ingreso == undefined) {
          setcargaExitosaSubModalidad(false)
        }

        setGuidSubModalidad(docs.guid_submodalidad_ingreso);
        // Se determina el tipo de ficha y el titulo dependiendo de la version del CRM
        if (version_crm == "crm2011") {
          if (docs.codigo_linea_negocio != null || docs.codigo_linea_negocio != "") {
            var tipoFicha = 0;

            if (docs.codigo_linea_negocio == "709460002") {
              tipoFicha = 1;
            }
            else if (docs.codigo_linea_negocio == "709460000") {
              tipoFicha = 2;

              if(docs.guid_horario==null || docs.guid_horario==''){
                setErrMsg('No se estableció un horario para la ficha de postulación. Comunicarse con área de Admisión.');
              }

            }
            else if (docs.codigo_linea_negocio == "709460001") {
              tipoFicha = 3;
            }
            setvalorTipoFicha(tipoFicha)
          }
        }
        else if (version_crm == "crm365") {
          
          if (docs.codigo_unidad_negocio) {
            let tipoFicha = 0;

            const { codigo_unidad_negocio, guid_modalidad_estudio, guid_horario } = docs;

            if (codigo_unidad_negocio === UNIDADES_NEGOCIO.PG) {
                tipoFicha = 1; // PG              
            }
            else if (codigo_unidad_negocio === UNIDADES_NEGOCIO.WA) {
              if (!guid_modalidad_estudio || guid_modalidad_estudio === MODALIDADES_ESTUDIO.PRESENCIAL) {
                tipoFicha = 2; // WA
              }
              else if (guid_modalidad_estudio === MODALIDADES_ESTUDIO.DISTANCIA) {
                tipoFicha = 4; // WA_Carrera_Distancia
              }
              else if (guid_modalidad_estudio === MODALIDADES_ESTUDIO.SEMIPRESENCIAL) {
                tipoFicha = 5; // WA_Semipresencial
              }

              if (!guid_horario) {
                setErrMsg('No se estableció un horario para la ficha de postulación. Comunicarse con área de Admisión.');
              }
            }
            else if (codigo_unidad_negocio === UNIDADES_NEGOCIO.EPEC) {
              tipoFicha = 3; // EPEC
            }
            else if (codigo_unidad_negocio === UNIDADES_NEGOCIO.WV) {
              tipoFicha = 4; // WAV (Histórico)
              if (!guid_horario) {
                setErrMsg('No se estableció un horario para la ficha de postulación. Comunicarse con área de Admisión.');
              }
            }
            else if (codigo_unidad_negocio === UNIDADES_NEGOCIO.WAS) {
              tipoFicha = 5; // WAS (Histórico)
              if (!guid_horario) {
                setErrMsg('No se estableció un horario para la ficha de postulación. Comunicarse con área de Admisión.');
              }
            }

            setvalorTipoFicha(tipoFicha);
            setmodadlidadIngreso(response.data.guid_modalidad_ingreso)
          }
        }

        var valoredadActual = getAge(docs.fecha_nacimiento)
        setedadActual(valoredadActual);
        validator.current.purgeFields();
        if (docs.periodo_banner == null || docs.periodo_banner == undefined) {
          setPeriodoBanner('NoTienePeriodoBanner');
        } else {
          setPeriodoBanner(docs.periodo_banner);
        }
        setPost(docs)
        setLoading(false);
        return response.data;
      })
      .catch(err => {
      });
  }


  async function obtenerListadoDeclaracion(guid_submodalidad_ingreso) {
    var auth = {
      headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm }
    };
    axios.get(baseUrlGDO + 'api/submodalidades/' + guid_submodalidad_ingreso + '/declaraciones_juradas', auth)
      .then(response => {
        const docs = response.data
        setPostDeclaracion(docs);
        return response.data;
      })
      .catch(err => {
      });
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    const resp = await fetch(`${urlAPIVulnerabilidad}/cuestionario-prospecto/4/${guid_oportunidad}/completado`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtUsuario}`,
      }
    })
    const respVulnerabilidad= await resp.json()
    setTxtVulnerabilidad(respVulnerabilidad.details.result)

    if (validator.current.allValid() && respVulnerabilidad.details.result) {
      setactivarBoton(false);
      handleShow();
    }
    else {
      validator.current.showMessages();
      forceUpdate(1)
      setactivarBoton(true)
    }
  }

  function enviarFuncionAceptar() {
    if (activarBoton == false) {
      enviarRegistro(guid_oportunidad)
      handleClose()
    }
  }



  async function obtenerRegistroId(guid_oportunidad) {

    var auth = {
      headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm }
    };
    axios.get(baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + FICHA_URL, auth)
      .then(response => {
        const data = response.data
        setPostObtenerRegistroId(data.obj.idFichaMatricula);
        return response.data.obj;
      })
      .catch(err => {

      });
  }

  async function enviarRegistro(guid) {
    setLoading(true);
    if (aceptoTyCNew) {

      const response = await axios.post(baseUrlGDO + 'api/oportunidades/' + guid + FICHA_URL,
        JSON.stringify({
          "GuidSede": datoUsuario.guid_sede,
          "Sede": datoUsuario.nombre_sede,
          "GuidCarrera": datoUsuario.guid_carrera,
          "Carrera": datoUsuario.nombre_carrera,
          "GuidCampania": datoUsuario.guid_campania,
          "Campania": datoUsuario.nombre_campania,
          "GuidModalidadEstudio": datoUsuario.guid_modalidad_estudio == null ? "-" : datoUsuario.guid_modalidad_estudio,
          "ModalidadEstudio": datoUsuario.nombre_modalidad_estudio == null ? "-" : datoUsuario.nombre_modalidad_estudio,
          "GuidModalidadIngreso": datoUsuario.guid_modalidad_ingreso,
          "ModalidadIngreso": datoUsuario.nombre_modalidad_ingreso,
          "GuidSubModalidadIngreso": datoUsuario.guid_submodalidad_ingreso,
          "SubModalidadIngreso": datoUsuario.nombre_submodalidad_ingreso,
          "SubModalidadTieneBeneficioEconomico": datoUsuario.submodalidad_tiene_beneficio_economico,
          "GuidOportunidad": datoUsuario.guid_oportunidad,
          "IdTipoFichaMatricula": valorTipoFicha,
          "ApellidoPaterno": datoUsuario.apellido_paterno,
          "ApellidoMaterno": datoUsuario.apellido_materno,
          "Nombres": datoUsuario.nombres,
          "CodigoTipoDocumento": datoUsuario.codigo_tipo_documento,
          "TipoDocumento": Documento.nombre,
          "NumeroDocumento": datoUsuario.documento_identidad,
          "CodigoSexo": datoUsuario.codigo_genero,
          "Sexo": datoUsuario.nombre_genero,
          "FechaNacimiento": datoUsuario.fecha_nacimiento,
          "Direccion": direccion,
          "GuidDepartamento": departamento.guid,
          "Departamento": departamento.nombre,
          "GuidProvincia": provincia.guid,
          "Provincia": provincia.nombre,
          "GuidDistrito": distrito.guid,
          "Distrito": distrito.nombre,
          "TelefonoCasa": telefonoFijo,
          "TelefonoCelular": celular,
          "Email": correoElectronico,
          "Usuario": usuarios,
          "AutorizoOpcionalmenteUsoDatosPersonales": autorizoOpcionalmenteUsoDatosPersonalesNew,
          "AceptoTyC": aceptoTyCNew,
          "EmailConsejero": datoUsuario.email_consejero,
          "EmailPropietario": datoUsuario.email_propietario,
          "PeriodoBanner": datoUsuario.periodo_banner,
          "Apoderado":
            edadActual >= 18 ? null :
              {
                "IdRelacionApoderado": Relacion.id,
                "Ocupacion": Ocupacion,
                "ApellidoPaterno": ApellidoPaternoApoderado,
                "ApellidoMaterno": ApellidoMaternoApoderado,
                "Nombres": NombresApoderado,
                "CodigoTipoDocumento": DocumentoApoderado.codigo,
                "TipoDocumento": DocumentoApoderado.nombre,
                "NumeroDocumento": NumeroDocumentoApoderado,
                "Direccion": DireccionApoderado,
                "GuidDepartamento": DepApoderado.guid,
                "Departamento": DepApoderado.nombre,
                "GuidProvincia": ProvApoderado.guid,
                "Provincia": ProvApoderado.nombre,
                "GuidDistrito": DistApoderado.guid,
                "Distrito": DistApoderado.nombre,
                "TelefonoCasa": TelefonoCasaApoderado,
                "TelefonoCelular": celularApoderado,
                "Email": mailApoderado
              },
          "Adjuntos": [],
          "Declaraciones": datosDeclaracion,
          "AutorizoUsoDatosPersonales":esobligatoriounvalor,
          "Inscripcion": valorTipoFicha == 1 ? {} :
            {
              "esTrabajadorDependiente": tipoTrabajo == 1 ? true : false,
              "razonSocial": razonSocialTrab,
              "ruc": rucTrab,
              "GuidDepartamentoTrabajo": departamentoTrab.guid,
              "DepartamentoTrabajo": departamentoTrab.nombre,
              "GuidProvinciaTrabajo": provinciaTrab.guid,
              "ProvinciaTrabajo": provinciaTrab.nombre,
              "GuidDistritoTrabajo": distritoTrab.guid,
              "DistritoTrabajo": distritoTrab.nombre,
              "Telefono": telefonoTrab,
              "Anexo": anexoTrab,
              "GuidHorario": Horarios.codigo,
              "Horario": Horarios.nombre,
              "NivelEstudios": 0
            }
        }),
        {
          headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm },
          withCredentials: true
        }
      ).catch(function (err) {
        setSuccessRegistro(false)
        if (err.response) {
          setErrMsg(err.response.data.message);
        } else if (err.request) {
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        } else {
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        }
      });

      const id_fichaMatricula = response?.data.idFichaMatricula;
      setFichaMatricula(id_fichaMatricula);
      const accessToken = response?.data?.accessToken;
      setSuccessRegistro(true);

    }
    setLoading(false);
  }

  const handleChange = (e) => {
    switch (e.target.id) {
      case 'direccion':
        setDireccionNew(e.target.value);
        break;
      case 'telefonoFijo':
        setTelefonoFijoNew(e.target.value);
        break;
      case 'celular':
        setCelularNew(e.target.value);
        break;
      case 'correoElectronico':
        setCorreoElectronicoNew(e.target.value);
        break;
      case 'razonSocial':
        setRazonSocialTrabNew(e.target.value);
        break;
      case 'ruc':
        setRucTrabNew(e.target.value);
        break;
      case 'TelefonoTrab':
        setTelefonoTrabNew(e.target.value);
        break;
      case 'AnexoTrab':
        setAnexoTrabNew(e.target.value);
        break;
      case 'Relacion':
        setRelacion(e.target.value);
        break;
      case 'ApellidoPaternoApoderado':
        setApellidoPaternoApoderado(e.target.value);
        break;
      case 'NombresApoderado':
        setNombresApoderado(e.target.value);
        break;
      case 'NúmeroDocumento':
        setNumeroDocumentoApoderado(e.target.value);
        break;
      case 'DirecciónApoderado':
        setDireccionApoderado(e.target.value);
        break;
      case 'celularApoderado':
        setcelularApoderado(e.target.value);
        break;
      case 'mailApoderado':
        setmailApoderado(e.target.value);
        break;
      case 'Ocupación':
        setOcupacion(e.target.value);
        break;
      case 'ApellidoMaternoApoderado':
        setApellidoMaternoApoderado(e.target.value);
        break;
      case 'TeléfonoCasa':
        setTelefonoCasaApoderado(e.target.value);
        break;

      default:
        break;
    }
  }

  function limpiartInputInformacionLaboral() {
    setRazonSocialTrabNew('')
    setRucTrabNew('')
    setTelefonoTrabNew('')
    setAnexoTrabNew('')
  }

  useEffect(async () => {
    setUrlVulnerabilidad(`${baseUrlVul}&tk=${jwtUsuario}`);
  },[]);

  useEffect(() => {
    function loadRegistro() {
      const response = obtenerRegistro(guid_oportunidad)
      return response
    }
    loadRegistro()

  }, [guid_oportunidad]);

  useEffect(() => {
    setDireccionNew(datoUsuario.direccion);
    setTelefonoFijoNew(datoUsuario.telefono_fijo);
    setCelularNew(datoUsuario.celular);
    setCorreoElectronicoNew(datoUsuario.correo_electronico);
    setAutorizoOpcionalmenteUsoDatosPersonalesNew(datoUsuario.autorizoOpcionalmenteUsoDatosPersonales);
    setAceptoTyCNew(datoUsuario.aceptarTyC);
    obtenerListadoDeclaracion(datoUsuario.guid_submodalidad_ingreso);
    setApellidoPaternoApoderado(datoUsuario.apellido_paterno_apoderado);
    setNombresApoderado(datoUsuario.nombres_apoderado);
    setDireccionApoderado(datoUsuario.direccion_apoderado);
    setcelularApoderado(datoUsuario.celular_apoderado);
    setmailApoderado(datoUsuario.correo_electronico_apoderado);
    setApellidoMaternoApoderado(datoUsuario.apellido_materno_apoderado);
    setDocumentoApoderado(datoUsuario.codigo_tipo_documento, 'nn', datoUsuario.numeroDocumento);
    obtenerRegistroId(guid_oportunidad);

  }, [datoUsuario]);

  if (!datoUsuario) return "No se encontró datos";

  const handleLocationRelacion = (id, nombres) => {
    setRelacion({ id: id, nombre: nombres })
  }

  const handleCargaMatrizDocumento = (data) => {
    setCargaMatrizDocumento(data);
  }


  const handleVistas = (id, nombre, url, visible) => {
    setvistaCargaDocumento({ id: id, nombre: nombre, url: url, visible: visible });

  }

  const handleLocationTrabajo = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDepartamentoTrabNew({ guid: guid_dep, nombre: nombre_dep });
    setProvinciaTrabNew({ guid: guid_prov, nombre: nombre_prov });
    setDistritoTrabNew({ guid: guid_dist, nombre: nombre_dist });
  }

  const handleLocationPersonal = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDep({ guid: guid_dep, nombre: nombre_dep });
    setProv({ guid: guid_prov, nombre: nombre_prov });
    setDist({ guid: guid_dist, nombre: nombre_dist });
  }

  const handleLocationPersonalApoderado = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDepApoderado({ guid: guid_dep, nombre: nombre_dep });
    setProvApoderado({ guid: guid_prov, nombre: nombre_prov });
    setDistApoderado({ guid: guid_dist, nombre: nombre_dist });
  }

  const handleDoc = (codigo_doc, nombre_doc, numero_doc) => {
    setDocumento({ codigo: codigo_doc, nombre: nombre_doc, numero: numero_doc });

  }

  const handleDocApoderado = (codigo_doc, nombre_doc, numero_doc) => {
    setDocumentoApoderado({ codigo: codigo_doc, nombre: nombre_doc, numero: numero_doc });
  }

  const handleAceptarTyC = (aceptarTyC) => {
    if (!aceptarTyC) {
      setAceptoTyCNew('');
    }
    else {
      setAceptoTyCNew(aceptarTyC);
    }
  }

  const retroceder = async (e) => {
    setNavegacionRetroceder(true);
  }

  if (NavegacionRetroceder) {
    return <Navigate to="/" />
  }


  console.log(valorTipoFicha);
  console.log(Horarios.codigo);
  console.log(Horarios.nombre);

  function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) { age--; }
    return age;
  }


  var mensaje = ''
  if (PostObtenerRegistroId > 0) {
    mensaje = 'Tienes una ficha de postulación registrada.'
  } else if (CargaMatrizDocumento == false) {
    mensaje = 'No se estableció una matriz documental para la submodalidad de ingreso. Comunicarse con área de Admisión.'
  }
  else if (GuidSubModalidad == null) {
    mensaje = 'No se estableció la submodalidad de ingreso para la ficha de postulación. Comunicarse con área de Admisión.'
  } else if (errMsg != '') {
    mensaje = errMsg
  }

  return (
    <>
      {
        cargaExitosaSubModalidad == false ?
          (
            <MensajeValidacion
              mensaje={mensaje}
            >
            </MensajeValidacion>
          )
          :
          (PostObtenerRegistroId > 0 || CargaMatrizDocumento == false || errMsg != '' ?
            <MensajeValidacion
              mensaje={mensaje}
            >
            </MensajeValidacion>
            :
            <div>
              <Helmet>
                <title>Ficha de Postulación</title>
              </Helmet>
              {
                vistaCargaDocumento.visible == true ?
                  (<UploaderDocument
                    guid_oportunidad={guid_oportunidad}
                    idTipoDoc={vistaCargaDocumento.id}
                    tipoDoc={vistaCargaDocumento.nombre}
                    versiones={vistaCargaDocumento.url}
                    handleVistas={handleVistas}
                    sololectura={false}
                  >
                  </UploaderDocument>) : ('')
              }
              {showModal ? (
                <Modal show={showModal} onHide={handleClose}>
                  <Modal.Header /*closeButton*/ >
                    <Modal.Title>¿Estás seguro que la información ingresada es correcta?</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Asegúrate de completar tus datos correctamente en base a la información de tu DNI, los adjuntos de los mismos deben ser legibles, recuerda que una vez registrada tu información no podrás editarla.</Modal.Body>
                  <Modal.Footer>
                    <BotonGrisModal type="submit" onClick={handleClose}  /* onClick={handleCancelar} */>Cancelar</BotonGrisModal>
                    <BotonAmarilloModal
                      disabled={activarBoton}
                      onClick={enviarFuncionAceptar}
                      style={activarBoton == true ? { backgroundColor: '#ccc' } : { backgroundColor: '#ffc107' }}
                    >Aceptar
                    </BotonAmarilloModal>
                  </Modal.Footer>
                </Modal>
              )
                :
                (<></>)}
              {successRegistro ? (
                <section>
                  <Registro
                    ficha_matricula={idFichaMatricula}
                    urlapi={baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + FICHA_URL}
                    nombre={datoUsuario.nombres}
                  />
                </section>
              ) : (
                <>
                  <div style={vistaCargaDocumento.visible == true ? { 'display': 'none' } : { 'display': 'block' }}>
                    <Header> </Header>
                    <Navbar bg="dark" expand="lg" fixed="top">
                      <Navbar.Brand href="#">
                        <img
                          src="https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-fondo-oscuro.png"
                          width="160px"
                          className="d-inline-block align-top"
                        />
                      </Navbar.Brand>
                    </Navbar>
                    <Container style={{ 'margin-top': '8rem' }}>
                      <Titulo>
                        FICHA DE POSTULACIÓN
                      </Titulo>
                      <Formulario action="" onSubmit={handleSubmit}>
                        <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                          <Card.Body style={{ padding: '0px' }}>
                            <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem', fontSize: '18px' }}>DATOS GENERALES</Card.Title>
                            <Card.Text style={{ padding: '1rem' }}>
                              <Row>
                                <Col sm={4}>
                                  <ComponenteInput
                                    estilo="blocked"
                                    tipo="text"
                                    label="Sede"
                                    placeholder={datoUsuario.nombre_sede}
                                    name="sede"
                                    leyendaError="El usuario tiene que..."
                                    expresionRegular=""
                                  />
                                  {validator.current.message('Sede', datoUsuario.nombre_sede, 'required', { className: "text-danger" })}
                                </Col>
                                <Col sm={4}>
                                  <ComponenteInput
                                    estilo="blocked"
                                    tipo="text"
                                    label="Periodo Académico"
                                    placeholder={datoUsuario.nombre_campania}
                                    name="usuario"
                                    leyendaError="El usuario tiene que..."
                                    expresionRegular=""
                                  />
                                  {validator.current.message('Periodo Académico', datoUsuario.nombre_campania, 'required', { className: "text-danger" })}
                                </Col>
                                <Col sm={4}>
                                  <ComponenteInput
                                    estilo="blocked"
                                    tipo="text"
                                    label="Tipo de Admisión"
                                    placeholder={datoUsuario.nombre_modalidad_ingreso}
                                    name="usuario"
                                    leyendaError="El usuario tiene que..."
                                    expresionRegular=""
                                  />
                                  {validator.current.message('Tipo de Admisión', datoUsuario.nombre_modalidad_ingreso, 'required', { className: "text-danger" })}
                                </Col>
                              </Row>
                              <Row>
                                  <Col sm={4}>
                                  <ComponenteInput
                                    estilo="blocked"
                                    tipo="text"
                                    label="Carrera"
                                    placeholder={datoUsuario.nombre_carrera}
                                    name="usuario"
                                    leyendaError="El usuario tiene que..."
                                    expresionRegular=""
                                  />
                                  {validator.current.message('Carrera', datoUsuario.nombre_carrera, 'required', { className: "text-danger" })}
                                </Col>
                                {!loading ? (
                                  <>
                                    <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Modalidad Estudio"
                                      placeholder={datoUsuario.nombre_modalidad_estudio == null ? "-" : datoUsuario.nombre_modalidad_estudio}
                                      name="usuario"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                    />
                                  </Col>
                                  </>
                                ) : (<></>)
                              }
                                <Col sm={4}>
                                  <ComponenteInput
                                    estilo="blocked"
                                    tipo="text"
                                    label="Subtipo de Admisión"
                                    placeholder={datoUsuario.nombre_submodalidad_ingreso}
                                    name="usuario"
                                    leyendaError="El usuario tiene que..."
                                    expresionRegular=""
                                  />
                                  {validator.current.message('Subtipo de Admisión', datoUsuario.nombre_submodalidad_ingreso, 'required', { className: "text-danger" })}
                                </Col>
                              </Row>
                            </Card.Text>
                          </Card.Body>
                        </Card>
                        <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                          <Card.Body style={{ padding: '0px' }}>
                            <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DATOS PERSONALES</Card.Title>
                            <Card.Text style={{ padding: '1rem' }}>
                              <Formulario action="">
                                <Row>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Apellido Paterno"
                                      placeholder={datoUsuario.apellido_paterno}
                                      name="usuario"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                    />
                                    {validator.current.message('Apellido Paterno', datoUsuario.apellido_paterno, 'required', { className: "text-danger" })}
                                  </Col>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Apellido Materno"
                                      placeholder={datoUsuario.apellido_materno}
                                      name="usuario"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Nombres"
                                      placeholder={datoUsuario.nombres}
                                      name="usuario"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                    />
                                    {validator.current.message('Nombres', datoUsuario.nombres, 'required', { className: "text-danger" })}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={4}>
                                    <SelectDocumento
                                      estilo="blocked"
                                      name="tipo_documento"
                                      urlapi={baseUrlCRM + 'api/tipos_documento'}
                                      handleDoc={handleDoc}
                                      guidDocumento={datoUsuario.codigo_tipo_documento == null ? "" : datoUsuario.codigo_tipo_documento}
                                      versionCRM={version_crm}
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Número de Documento"
                                      placeholder={datoUsuario.documento_identidad}
                                      name="usuario"
                                      leyendaError="Debe ingresar un número de documento"
                                      expresionRegular="/[0-9]{8}/"
                                    />
                                    {validator.current.message('Número de Documento', datoUsuario.documento_identidad, 'required', { className: "text-danger" })}
                                  </Col>
                                  <Col sm={4}>
                                    <ComponenteSelectSexo
                                      estilo="blocked"
                                      label="Sexo"
                                      placeholder="--SELECCIONE--"
                                      name="Sexo"
                                      guidSexo={datoUsuario.codigo_genero}
                                      validator={validator}
                                      esobligatorio={true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      estilo="blocked"
                                      tipo="text"
                                      label="Fecha de nacimiento"
                                      placeholder={moment(datoUsuario.fecha_nacimiento).format('DD/MM/YYYY')}
                                      name="usuario"
                                      leyendaError="Fecha de nacimiento en rango no válido"
                                      expresionRegular=""
                                    />
                                    <label>Edad: {getAge(datoUsuario.fecha_nacimiento)} años</label>
                                  </Col>
                                </Row>
                                <Row>
                                  <SelectUbicacion
                                    name="departamentos"
                                    handleLocation={handleLocationPersonal}
                                    validator={validator}
                                    esobligatorio={true}
                                    guid_dep={datoUsuario.guid_departamento_contacto == null ? "" : datoUsuario.guid_departamento_contacto}
                                    guid_prov={datoUsuario.guid_provincia_contacto == null ? "" : datoUsuario.guid_provincia_contacto}
                                    guid_dist={datoUsuario.guid_distrito_contacto == null ? "" : datoUsuario.guid_distrito_contacto}
                                    versionCRM={version_crm}
                                  />
                                </Row>
                                <Row>
                                  <Col sm={12}>
                                    <ComponenteInput
                                      tipo="text"
                                      label="Dirección (Urb., Calle, Jr., Av.)"
                                      placeholder=""
                                      name="direccion"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo=""
                                      value={direccion}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      tipo="text"
                                      label="Teléfono Casa"
                                      placeholder="(00)0000000"
                                      //value = {datoUsuario.telefono_fijo}
                                      name="telefonoFijo"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo=""
                                      value={telefonoFijo}
                                      onChange={handleChange}
                                    />
                                  </Col>
                                  <Col sm={4}>
                                    <ComponenteInput
                                      tipo="text"
                                      label="Teléfono Celular"
                                      placeholder=""
                                      name="celular"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo=""
                                      value={celular}
                                      onChange={handleChange}
                                    />
                                    {validator.current.message('teléfono celular', celular, 'required|numeric|min:9', { className: "text-danger" })}
                                  </Col>

                                  <Col sm={4}>
                                    <ComponenteInput
                                      tipo="text"
                                      label="E-mail"
                                      placeholder=""
                                      name="correoElectronico"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo=""
                                      value={correoElectronico}
                                      onChange={handleChange}
                                    />
                                    {validator.current.message('e-mail', correoElectronico, 'required|email', { className: "text-danger" })}
                                  </Col>

                                </Row>
                              </Formulario>
                            </Card.Text>
                          </Card.Body>
                        </Card>
                        {
                          edadActual < 18 ? (
                              <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                                <Card.Body style={{ padding: '0px' }}>
                                  <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DATOS DEL PADRE O APODERADO</Card.Title>
                                  <Card.Text style={{ padding: '1rem' }}>
                                    <Formulario action="">
                                      <Row>
      
                                        <Col sm={4}>
                                          <ComponenteSelectRelacion
                                            name="Relacion"
                                            handleLocation={handleLocationRelacion}
                                            seleccion=''
                                            validator={validator}
                                            esobligatorio={true}
                                            guidRelacion={''}
      
                                          />
                                        </Col>
      
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Ocupación"
                                            placeholder=""
                                            name="Ocupación"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular=""
                                            estilo=""
                                            value={Ocupacion}
                                            onChange={handleChange}
                                          />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Apellido Paterno"
                                            placeholder=""
                                            name="ApellidoPaternoApoderado"
                                            leyendaError="Apellido Paterno..."
                                            expresionRegular=""
                                            estilo=""
                                            value={ApellidoPaternoApoderado}
                                            onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('Apellido Paterno', ApellidoPaternoApoderado, 'required', { className: "text-danger" }) : ""}
                                        </Col>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Apellido Materno"
                                            placeholder=""
                                            name="ApellidoMaternoApoderado"
                                            leyendaError="El Apellido Materno..."
                                            expresionRegular=""
                                            estilo=""
                                            value={ApellidoMaternoApoderado}
                                            onChange={handleChange}
                                          />
                                        </Col>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Nombre Apoderado"
                                            placeholder=""
                                            name="NombresApoderado"
                                            leyendaError="Nombres"
                                            expresionRegular=""
                                            estilo=""
                                            value={NombresApoderado}
                                            onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('Nombre Apoderado', NombresApoderado, 'required', { className: "text-danger" }) : ""}
                                        </Col>
                                      </Row>
      
                                      <Row>
                                        <Col sm={4}>
                                          <SelectDocumento
                                            name="tipo_documento"
                                            urlapi={baseUrlCRM + "api/tipos_documento"}
                                            seleccion=''
                                            handleDoc={handleDocApoderado}
                                            validator={validator}
                                            esobligatorio={true}
                                            guidDocumento={""}
                                            versionCRM={version_crm}
                                          />
                                        </Col>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Número de Documento"
                                            placeholder=""
                                            name="NúmeroDocumento"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular="/[0-9]{8}/"
                                            value={NumeroDocumentoApoderado}
                                            onChange={handleChange}
      
                                          />
                                          {esobligatorioVal ? validator.current.message('Número de Documento', NumeroDocumentoApoderado, 'required', { className: "text-danger" }) : ""}
                                        </Col>
                                      </Row>
                                      <Row>
                                        <SelectUbicacion
                                          name="departamentos"
                                          handleLocation={handleLocationPersonalApoderado}
                                          validator={validator}
                                          esobligatorio={true}
                                          guid_dep={datoUsuario.guid_departamento_apoderado == null ? "" : datoUsuario.guid_departamento_apoderado}
                                          guid_prov={datoUsuario.guid_provincia_apoderado == null ? "" : datoUsuario.guid_provincia_apoderado}
                                          guid_dist={datoUsuario.guid_distrito_apoderado == null ? "" : datoUsuario.guid_distrito_apoderado}
                                          versionCRM={version_crm}
                                        />
                                      </Row>
                                      <Row>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Dirección (Urb., Calle, Jr, Av.)"
                                            placeholder=""
                                            name="DirecciónApoderado"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular=""
                                            estilo=""
                                            value={DireccionApoderado}
                                            onChange={handleChange}
                                          />
                                        </Col>
                                        {esobligatorioVal ? validator.current.message('Dirección (Urb., Calle, Jr, Av.)', DireccionApoderado, 'required', { className: "text-danger" }) : ""}
                                      </Row>
                                      <Row>
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Teléfono Casa"
                                            placeholder="(00)0000000"
                                            name="TeléfonoCasa"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular=""
                                            estilo=""
                                            value={TelefonoCasaApoderado}
                                            onChange={handleChange}
                                          />
                                        </Col>
      
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="Teléfono Celular"
                                            placeholder=""
                                            name="celularApoderado"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular=""
                                            estilo=""
                                            value={celularApoderado}
                                            onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('Teléfono Celular', celularApoderado, 'required', { className: "text-danger" }) : ""}
      
                                        </Col>
      
                                        <Col sm={4}>
                                          <ComponenteInput
                                            tipo="text"
                                            label="E-mail"
                                            placeholder=""
                                            name="mailApoderado"
                                            leyendaError="El usuario tiene que..."
                                            expresionRegular=""
                                            estilo=""
                                            value={mailApoderado}
                                            onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('E-mail', mailApoderado, 'required|email', { className: "text-danger" }) : ""}
      
                                        </Col>
                                      </Row>
                                    </Formulario>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                          ) : (<div></div>)
                        }
                        {
                          valorTipoFicha != 1  ? (
                              <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                                  <Card.Body style={{ padding: '0px' }}>
                                  <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>INFORMACIÓN DEL CENTRO LABORAL</Card.Title>
                                  <Card.Text style={{ padding: '1rem' }}>
                                      <Formulario action="">
                                      <Row>
                                          <Col sm={12}>
                                          <text>Trabajo prestado en forma</text>
                                          <Wrapper>
                                              <Col sm={6}>
                                              <Item>
                                                  <RadioButton
                                                  type="radio"
                                                  name="radio"
                                                  value="1"
                                                  checked={tipoTrabajo === "1"}
                                                  onChange={(event) => handleRadioButton(event)}
                                                  />
                                                  <RadioButtonLabel />
                                                  <div>Dependiente</div>
                                              </Item>
                                              </Col>
                                              <Col sm={6}>
                                              <Item>
                                                  <RadioButton
                                                  type="radio"
                                                  name="radio"
                                                  value="2"
                                                  checked={tipoTrabajo === "2"}
                                                  onChange={(event) => handleRadioButton(event)}
                                                  />
                                                  <RadioButtonLabel />
                                                  <div>Independiente</div>
                                              </Item>
                                              </Col>
                                          </Wrapper>
                                          </Col>
                                      </Row>
                                      <Row>
                                          <Col sm={8}>
                                          <ComponenteInput
                                              tipo="text"
                                              label="Razón Social"
                                              placeholder=""
                                              name="razonSocial"
                                              leyendaError="El usuario tiene que..."
                                              expresionRegular=""
                                              estilo={tipoTrabajo == "2" ? "blocked" : ""}
                                              value={razonSocialTrab}
                                              onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('razonSocial', razonSocialTrab, 'required', { className: "text-danger" }) : ""}

                                          </Col>
                                          <Col sm={4}>
                                          <ComponenteInput
                                              tipo="text"
                                              label="RUC"
                                              placeholder=""
                                              name="ruc"
                                              leyendaError="El usuario tiene que..."
                                              expresionRegular=""
                                              estilo={tipoTrabajo == "2" ? "blocked" : ""}
                                              value={rucTrab}
                                              onChange={handleChange}
                                          />
                                          </Col>
                                      </Row>
                                      <Row>
                                          <Col sm={12}>
                                          <SelectUbicacion
                                              name="departamentos"
                                              handleLocation={handleLocationTrabajo}
                                              estilo={tipoTrabajo == "2" ? "blocked" : ""}
                                              validator={validator}
                                              esobligatorio={tipoTrabajo == "1" ? true : false}
                                              guid_dep={""}
                                              guid_prov={""}
                                              guid_dist={""}
                                              versionCRM={version_crm}
                                          />
                                          </Col>
                                      </Row>
                                      <Row>
                                          <Col sm={6}>
                                          <ComponenteInput
                                              tipo="text"
                                              label="Teléfono"
                                              placeholder=""
                                              name="TelefonoTrab"
                                              leyendaError="El usuario tiene que..."
                                              expresionRegular=""
                                              estilo={tipoTrabajo == "2" ? "blocked" : ""}
                                              value={telefonoTrab}
                                              onChange={handleChange}
                                          />
                                          {esobligatorioVal ? validator.current.message('TelefonoTrab', telefonoTrab, 'required', { className: "text-danger" }) : ""}
                                          </Col>
                                          <Col sm={6}>
                                          <ComponenteInput
                                              tipo="text"
                                              label="Anexo"
                                              placeholder=""
                                              name="AnexoTrab"
                                              leyendaError="El usuario tiene que..."
                                              expresionRegular=""
                                              estilo={tipoTrabajo == "2" ? "blocked" : ""}
                                              value={anexoTrab}
                                              onChange={handleChange}
                                          />
                                          </Col>
                                      </Row>
                                      </Formulario>
                                  </Card.Text>
                                  </Card.Body>
                              </Card>
                          ) : (<div></div>)
                        }
                        {
                          valorTipoFicha == 2 ||  valorTipoFicha == 4 ||  valorTipoFicha == 5 ? (
                              <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                                <Card.Body style={{ padding: '0px' }}>
                                  <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>HORARIOS</Card.Title>
                                  <Card.Text style={{ padding: '1rem' }}>
                                    <Formulario action="">
                                      <Row>
                                        <Col sm={12}>
                                          <SelectHorario
                                            estilo={valorTipoFicha==2 ||  valorTipoFicha == 5 ?(""):("blocked")}
                                            label="Horarios Disponibles"
                                            placeholder="--SELECCIONE--"
                                            name="nombre_horario"
                                            urlapi={baseUrlCRM + "api/horarios"}
                                            versionCRM={version_crm}
                                            validator={validator}
                                            esobligatorio={true}
                                            handleHorario={handleHorario}
                                            guidHorario={datoUsuario.guid_horario}
                                          />
                                        </Col>
                                      </Row>
                                    </Formulario>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                          ) : (<div></div>)
                        }
                        {
                          vistaCargaDocumento.visible == false ?
                              <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                                <Card.Body style={{ padding: '0px' }}>
                                  <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DOCUMENTOS PARA MATRÍCULA</Card.Title>
                                  <Card.Text style={{ padding: '1rem' }}>
                                    {loading == false && datoUsuario.guid_submodalidad_ingreso != undefined ?

                                      <Documentos
                                        guid_oportunidad={guid_oportunidad}
                                        validator={validator}
                                        guid_sub_modalidad_ingreso={datoUsuario.guid_submodalidad_ingreso}
                                        handleVistas={handleVistas}
                                        handleCargaMatrizDocumento={handleCargaMatrizDocumento}
                                        beneficiosEconomicos={datoUsuario.submodalidad_tiene_beneficio_economico}
                                        sololectura={false}
                                      /> : ('')}

                                  </Card.Text>
                                </Card.Body>
                              </Card> : ""
                        }

                        <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                              <Card.Body style={{ padding: '0px' }}>
                                <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>BIENESTAR</Card.Title>
                                <Card.Text style={{ padding: '1rem' }}>
                                En nuestra Universidad tenemos en cuenta la diversidad de necesidades, potencial y deseo de superación de nuestros estudiantes a lo largo de su vida universitaria. Es por ello por lo que consideramos muy importante reducir barreras y buscar permanentemente la equidad y la inclusión a través de acciones que conlleven a que todos los estudiantes permanezcan y concluyan sus estudios universitarios. Te pedimos respondas a las siguientes preguntas para orientarte y ofrecerte alguno de nuestros programas o servicios creados para este fin:
                                <br />
                                <a target="_blank" href={urlVulnerabilidad}>Cuestionario de discapacidad</a>
                                <div className="text-danger" style={{display: txtVulnerabilidad ? 'none' : 'block' }}>El cuestionario de discapacidad es obligatorio</div>
                                <br />
                                </Card.Text>
                              </Card.Body>
                            </Card>

                        <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                          <Card.Body style={{ padding: '0px' }}>
                            <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DECLARACIONES / COMPROMISOS</Card.Title>
                            <Card.Text style={{ padding: '1rem' }}>
                              Declaro / me comprometo en lo siguiente:
                              <br />
                              {datosDeclaracion?.map((files, index) => {
                                return (
                                  files.id != null && files.id > 0 ?
                                    (
                                      <div className="card-block card-cuerpo">
                                        <div className="row check-contenedor">
                                          <div className="col-sm-12 custom-control custom-checkbox">

                                            <input type="checkbox" id={'chkDeclaracion_' + files.id} name={'chkDeclaracion_' + files.id}
                                              value={files.id}
                                              onChange={(event) => handleDeclaracion(event)}
                                            />

                                            <label
                                              className="custom-control-label d-inline" htmlFor={'chkDeclaracion_' + files.id}
                                            >
                                            </label>{files.descripcion}

                                            {validator.current.message('declaracion', files.isChecked, 'required', { className: "text-danger" })}

                                          </div>
                                        </div>
                                      </div>
                                    ) : (<div className="card-block card-cuerpo"></div>)
                                )
                              })}
                              <br />
                              <ContenedorAutorizacion>
                                <Label style={{ display: 'block' }}>
                                  <Check
                                    type='checkbox'
                                    onChange={(event) => handleAutorizoOpcionalmenteUsoDatosPersonalesNew(event)}
                                    label={
                                      <span>
                                        Opcionalmente, autorizo el tratamiento de mis datos personales para las finalidades comerciales adicionales descritas en el siguiente
                                        <br />
                                        <a target="_blank" href="https://www.upn.edu.pe/sites/default/files/documentos/autorizacion-para-finalidades-adicionales.pdf">https://www.upn.edu.pe/sites/default/files/documentos/autorizacion-para-finalidades-adicionales.pdf</a>
                                      </span>
                                    }
                                    style={{ color: 'var(--bs-body-color)' }}
                                  />
                                </Label>
                              </ContenedorAutorizacion>
                              <br />
                              <label>Autorizo el tratamiento de mis datos personales para finalidades informativas y comerciales, conforme al siguiente</label>
                              <PoliticasDatosPersonales>
                                <label style={{ display: 'block' }}>
                                  <div>
                                  </div>
                                  <a target="_blank" href="https://www.upn.edu.pe/politica-de-privacidad">
                                    https://www.upn.edu.pe/politica-de-privacidad</a>
                                  <br />
                                  <label style={{ color: 'var(--bs-body-color)' }}>
                                    Sin mi autorización, no podrán comunicarse conmigo
                                  </label>
                                  <Col sm={6}>
                                    <Item>
                                      <RadioButton
                                        type="radio"
                                        name="radio"
                                        value="1"
                                        checked={tipoPoliticaPersonales === "1"}
                                        onChange={(event) => handleRadioButtonPoliticas(event)}
                                      />
                                      <RadioButtonLabel />
                                      <div>Si, Autorizo</div>
                                    </Item>
                                  </Col>

                                  <Col sm={6}>
                                    <Item>
                                      <RadioButton
                                        type="radio"
                                        name="radio"
                                        value="2"
                                        checked={tipoPoliticaPersonales === "2"}
                                        onChange={(event) => handleRadioButtonPoliticas(event)}
                                      />
                                      <RadioButtonLabel />
                                      <div>No, Autorizo</div>
                                    </Item>
                                  </Col>

                                  {validator.current.message('autorización', tipoPoliticaPersonales, 'required', { className: "text-danger" })}
                                </label>
                              </PoliticasDatosPersonales>
                              <br />
                              <ContenedorTerminos>
                                <Label>
                                  <Check
                                    type='checkbox'
                                    checked={aceptoTyCNew}
                                    inline
                                  />
                                  <VentanaModalion
                                    handleAceptarTyC={handleAceptarTyC}
                                    tipoServicio={PeriodoBanner}
                                    valorTipoFicha={valorTipoFicha}
                                    modadlidadIngreso={modadlidadIngreso}
                                  />
                                  {validator.current.message('terminos', aceptoTyCNew, 'required', { className: "text-danger" })}
                                </Label>
                              </ContenedorTerminos>

                              {false && <MensajeError>
                                <p>
                                  <FontAwesomeIcon icon={faExclamationTriangle} />
                                  <b>Error:</b> Por favor rellena el formulario correctamente.
                                </p>
                              </MensajeError>}
                              <ContenedorBotonCentrado>
                                <BotonAmarillo as="button" type="submit"  /*onChange={submitForm}*/ >Registrar</BotonAmarillo>
                                <MensajeExito>Formulario enviado exitosamente!</MensajeExito>
                                <BotonGris as='button' type='submit' onClick={retroceder}>Cancelar</BotonGris>
                                <MensajeExito>Formulario cancelado exitosamente!</MensajeExito>
                              </ContenedorBotonCentrado>
                            </Card.Text>
                          </Card.Body>
                        </Card>

                      </Formulario>
                      <Footer><p>© 2022 Universidad Privada del Norte</p></Footer>
                    </Container>
                  </div>
                </>
              )}
              <ProgressIntoDialog open={loading} />
            </div>
          )
      }
    </>
  );
}
export default Ficha;